// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xxBM9k6URM849zXRe4Al{flex-direction:column;display:flex}.xxBM9k6URM849zXRe4Al .MIoY6Zx0ASwt9kJScARS{column-gap:0;margin-top:11px!important}.d0T7cxiqRvYiPbRb2CxR{color:var(--content-brand-primary);margin:0 4px;text-decoration:none}._0ufQh2RUAv5kKARtoiw{color:var(--content-primary-tertiary);font-size:11px;font-style:normal;font-weight:400;line-height:13px}.BJ71mWy17qI5fnZjX9WD{border:1px solid var(--interaction-neutral-normal);background:var(--background-primary-inverted-primary);border-radius:6px;flex-direction:row;align-items:center;gap:8px;margin-top:16px;padding:8px 8px 8px 12px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fields": `xxBM9k6URM849zXRe4Al`,
	"note": `MIoY6Zx0ASwt9kJScARS`,
	"docLink": `d0T7cxiqRvYiPbRb2CxR`,
	"noteText": `_0ufQh2RUAv5kKARtoiw`,
	"tokenRow": `BJ71mWy17qI5fnZjX9WD`
};
export default ___CSS_LOADER_EXPORT___;
